"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _setupUserProvider = require("./setupUserProvider");
Object.keys(_setupUserProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _setupUserProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _setupUserProvider[key];
    }
  });
});
